// @flow

import type { StateType } from '../reducers';
import type { PaymentMean, PaymentStateType, PaymentAuthentication, PaymentAuthenticationResultType } from './reducer';
import { currentSubscriptionOuidSelector } from '../Dashboard/reducer';

export const hasStripeTimeOutSelector = (state: Object): boolean => state?.payment?.stripeTimeout;

export const paymentStateSelector = (state: StateType): PaymentStateType => state.payment;

export const paymentMeanSelector = (state: StateType): ?PaymentMean => {
  const paymentState = paymentStateSelector(state);
  switch (paymentState.type) {
    case 'STRIPE':
      if (!paymentState.stripeIntentId) return null;
      return {
        type: 'STRIPE',
        stripeCustomerId: paymentState.stripeCustomerId,
        stripeIntentId: paymentState.stripeIntentId,
        stripeIntentSecret: paymentState.stripeIntentSecret,
        stripeIntentStatus: paymentState.stripeIntentStatus,
        stripePaymentMethodId: paymentState.stripePaymentMethodId,
      };
    case 'BRAINTREE':
      if (!paymentState.braintreeNonce) return null;
      return {
        type: 'BRAINTREE',
        braintreeNonce: paymentState.braintreeNonce,
      };
    default:
      return null;
  }
};

export const paymentsSelector = (state: StateType): Object[] =>
  paymentStateSelector(state).history.filter(payment => {
    if (!payment.paymentRequests?.[0]) {
      return true;
    }

    const statusToDisplay = ['DONE', 'REJECTED', 'CANCELLED'];
    const paymentStatus = payment.paymentRequests?.[0]?.status;

    return statusToDisplay.includes(paymentStatus);
  });

export const braintreeClientTokenSelector = (state: StateType): ?string =>
  paymentStateSelector(state).braintreeClientToken;

export const paymentAuthenticationsSelector = (state: StateType): PaymentAuthentication[] =>
  paymentStateSelector(state).paymentAuthentications;

export const currentSubscriptionPaymentAuthenticationsSelector = (state: StateType): PaymentAuthentication[] => {
  const currentSubscriptionOuid = currentSubscriptionOuidSelector(state);
  return paymentAuthenticationsSelector(state).filter(
    (paymentAuthentication: PaymentAuthentication) => paymentAuthentication.subscriptionOuid === currentSubscriptionOuid
  );
};

export const paymentAuthenticationResultSelector = (state: StateType): PaymentAuthenticationResultType =>
  paymentStateSelector(state).paymentAuthenticationResult;

export const stripeRedirectUrlSelector = (state: StateType): string => paymentStateSelector(state).stripeRedirectUrl;

export const is3DSecureAuthentModalOpenSelector = (state: StateType): boolean =>
  paymentStateSelector(state).isThreeDSecureAuthentModalOpen;
